export const rgba = {
    black: 'rgba(0, 0, 0, 1)',
    partialBlack: 'rgba(0, 0, 0, 0.8)',
    transBlack: 'rgba(0, 0, 0, 1)',
    white: 'rgba(255, 255, 255, 1)',
    partialWhite: 'rgba(255, 255, 255, 0.8)',
    partialWhite2: 'rgba(255, 255, 255, 0.8)',
    red: 'rgba(252, 77, 61, 1.0)',
    blue1: 'rgba(50, 100, 168, 1)',
    blue2: 'rgba(50, 100, 168, 0.6)',
    blue3: 'rgba(50, 100, 168, 0.8)',
    green1: 'rgba(98, 217, 131, 1)',
    green2: 'rgba(98, 217, 131, 0.5)',
    yellow: 'rgba(255, 255, 0, 0.9)',
    orange: 'rgba(255, 165, 0, 1)',
    purple: 'rgba()',
    grey: 'rgba(190, 190, 190, 1)',
    tsprt_grey: 'rgba(190, 190, 190, 0.8)'
}

export const colors = {
    background: rgba.white,
    gridLines: rgba.grey,
    hoverVertex: rgba.tsprt_grey,
    hoverEdge: rgba.tsprt_grey,
    currentVertex: rgba.partialWhite,
    graphVertex: rgba.partialWhite,
    graphEdge: rgba.partialWhite,
    vertexPosition: rgba.yellow,
    edgeWeight: rgba.black,
    edgeWeightBackground: rgba.partialWhite,
    edgeWeightBorder: rgba.black,
    animRed: rgba.red,
    animBlue: rgba.blue1,
    animGreen: rgba.green1,
    animYellow: rgba.yellow,
    animOrange: rgba.orange
}

// const grid_shade = 190;
// const hover_shade = 190;

// const COLORS = {
//     grid_color: `rgba(${grid_shade}, ${grid_shade}, ${grid_shade})`,
//     node_hover_color: `rgba(${hover_shade}, ${hover_shade}, ${hover_shade}, 0.5)`,
//     // active_node_color: 'rgba(50, 100, 168, 0.7)',
//     active_node_color: 'rgba(255, 255, 255, 0.3)',
//     // current_node_color: 'rgba(98, 217, 131, 0.5)',
//     current_node_color: 'rgba(255, 255, 255, 0.7)',
//     inactive_node_color: `rgba(${hover_shade}, ${hover_shade}, ${hover_shade}, 0.7)`,
//     edge_hover_color: 'rgba(50, 100, 168, 0.5)',
//     hover_edge_color:'rgba(255, 255, 255, 0.3)',
//     directed_edge_color: 'rgba(255, 255, 255, 0.7)',
//     undirected_edge_color: 'rgba(255, 255, 255, 0.6)',
//     default_edge_color: 'rgba(50, 100, 168, 1)',
// }

// from drawFrame

// const colors = {
//     outV: 'rgba(57, 99, 237, 0.8)',
//     redV: 'rgba(252, 77, 61, 1.0)',
//     redE: 'rgba(252, 77, 61, 1.0)',
//     yellowV: 'rgba(255, 255, 0, 0.9)',
//     yellowE: 'rgba(255, 255, 0, 0.9)',
//     greenV: 'rgba(57, 237, 171, 0.8)',
//     greenE: 'rgba(57, 237, 171, 0.8)',
// }